import { ExternalLink } from 'react-feather';
import { StyledNextPrevious } from "..\\..\\..\\..\\src\\components\\styles\\PageNavigationButtons";
import React from 'react';
export default {
  ExternalLink,
  StyledNextPrevious,
  React
};